import { render, staticRenderFns } from "./CardSkeletonList.vue?vue&type=template&id=51f9986b"
import script from "./CardSkeletonList.vue?vue&type=script&lang=js"
export * from "./CardSkeletonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f9986b')) {
      api.createRecord('51f9986b', component.options)
    } else {
      api.reload('51f9986b', component.options)
    }
    module.hot.accept("./CardSkeletonList.vue?vue&type=template&id=51f9986b", function () {
      api.rerender('51f9986b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardSkeletonList.vue"
export default component.exports